import { defineFcm } from '../shared/factory';

export const FCM_STARFISH_SAP3_RECOMMENDED_ANGLES = defineFcm('starfish_sap3_recommended_angles')
	.asBoolean()
	.withDefault(false)
	.toConfig();
